import React from 'react';
import '../styles/Speisekarte.css'; // Make sure to create and import a style file
import sushiImg from '../assets/images/sushi Menü.png';
import VorspeisenImg from '../assets/images/Vorspeisen.png';
import EmpfehlungImg from '../assets/images/Empfehlung.png';
import dessertsImg from '../assets/images/desserts.png';
import BeilageImg from '../assets/images/Beilage.png';
import SuppenImg from '../assets/images/Suppen.png';
import KindertellerImg from '../assets/images/Kinderteller.png';
import Vegetarische_GerichteImg from '../assets/images/Vegetarische Gerichte.png';
import GetränkeImg from '../assets/images/Getränke.png';
import HELLOCHARGEImg from '../assets/images/U51 und13 Aund 14 A.png';

import 'swiper/css';
import 'swiper/css/autoplay';
import { useTranslation } from 'react-i18next';


function Speisekarte() {
    const { t } = useTranslation();

    const items = [
        { name: t('speisekarte.items.sushi'), img: sushiImg },
        { name: t('speisekarte.items.vorspeisen'), img: VorspeisenImg },
        { name: t('speisekarte.items.hauptspeisen'), img: HELLOCHARGEImg },
        { name: t('speisekarte.items.empfehlung'), img: EmpfehlungImg },
        { name: t('speisekarte.items.desserts'), img: dessertsImg },
        { name: t('speisekarte.items.beilage'), img: BeilageImg },
        { name: t('speisekarte.items.suppen'), img: SuppenImg },
        { name: t('speisekarte.items.vegetarisch'), img: Vegetarische_GerichteImg },
        { name: t('speisekarte.items.kinderteller'), img: KindertellerImg },
        { name: t('speisekarte.items.getränke'), img: GetränkeImg }
    ];

    return (
        <div className="specials">
            <div className="title">
                <button className="badge">{t('speisekarte.badge')}</button>
                <h1>{t('speisekarte.title')}</h1>
                <div className="divider">•••••</div>
            </div>

            <div className="menu-grid">

                {items.map((item, idx) => (
                    <div key={idx} className="menu-card">
                        <img src={item.img} alt={item.name} className="menu-img" />
                        <div className="menu-label">{item.name}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Speisekarte;
